export default __webpack_public_path__ + "static/article-how-to-plan-for-the-future-when-youre-living-in-the-now-df501ac15081a7c0347d2b527d8ded35.webp";